import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTaskStore } from "@/store/task";
import { Button } from "@/components/ui/Button";
import { WizardActionsBar } from "@/components/wizard/WizardActionsBar";
import { useIntakeProgressStore, getIntakeTaskKey } from "@/store/intakeProgress";

/**
 * Shown after portal case-history questionnaire is saved and the task is completed.
 */
export function TaskCompletePage() {
  const navigate = useNavigate();
  const setPortalCaseHistoryFlow = useTaskStore((s) => s.setPortalCaseHistoryFlow);
  const setCaseHistoryTaskAction = useTaskStore((s) => s.setCaseHistoryTaskAction);
  const setActivePortalTaskId = useTaskStore((s) => s.setActivePortalTaskId);

  useEffect(() => {
    // Task complete — clear its resume progress BEFORE the task id is cleared
    // (the progress key is derived from the active task id).
    useIntakeProgressStore.getState().resetTask(getIntakeTaskKey());
    setPortalCaseHistoryFlow(false);
    setCaseHistoryTaskAction(null);
    setActivePortalTaskId(null);
  }, [setPortalCaseHistoryFlow, setCaseHistoryTaskAction, setActivePortalTaskId]);

  return (
    <div className="wizard-page w-full px-4 py-10 text-center">
      <div className="wizard-page__content mx-auto max-w-md pb-4">
        <h1 className="mb-3 text-2xl font-semibold text-gray-900">Thank you</h1>
        <p className="text-sm text-gray-600">
          Your information has been submitted. You can return to your dashboard anytime.
        </p>
      </div>
      <WizardActionsBar>
        <span />
        <Button type="button" onClick={() => navigate("/")}>
          Back to dashboard
        </Button>
      </WizardActionsBar>
    </div>
  );
}
